import React, { FC } from 'react';
import styled from 'styled-components';
import {
  NameCell,
  TextWrapper,
} from 'components/organisms/timesheets/common/cells/name-cell';
import { SingleLineEllipsis } from 'components/styles';
import { CellWrapper, TextWrapperWithEllipsis } from './component';

interface Props {
  roleName: string;
  onWrapperClick: () => void;
}

const TitleCellWrapper = styled.div`
  display: flex;
`;

const RoleName = styled(TextWrapperWithEllipsis)`
  flex-grow: 1;
  max-width: 100%;
  ${SingleLineEllipsis};
`;

const StyledNameCell = styled(NameCell)`
  padding-right: 0 !important;

  ${TextWrapper} {
    width: 100%;
  }
`;

export const ExpandableRoleForUsersView: FC<Props> = ({
  roleName,
  onWrapperClick,
}) => {
  return (
    <CellWrapper onClick={onWrapperClick}>
      <StyledNameCell
        logo={null}
        primaryText={
          <TitleCellWrapper>
            <RoleName>{roleName}</RoleName>
          </TitleCellWrapper>
        }
      />
    </CellWrapper>
  );
};
